import styled from 'styled-components/macro'
import {motion} from 'framer-motion'
import { Link } from 'react-router-dom'

export const Container = styled.div`
    width: 90%;
    margin: 0 auto;
    max-width: var(--content-maxwidth);
    display: flex;
    justify-content: space-around;
    align-items: center;
    position: relative;

    @media all and (max-width: 650px) {
        margin-top: 6rem;
    }
`

export const CopyContent = styled.div`
    position: relative;
    left: 3%;
    top: 0;
    width: 30rem;
`

export const Copy = styled(motion.h1)`
    font-size: 4rem;
    position: relative;
    margin-bottom: 1rem;

    @media all and (max-width: 650px) {
        display: none;
    }
`

export const MobileCopy = styled(motion.h1)`
    display: none;

    @media all and (max-width: 650px) {
        display: block;
        font-size: 3rem;
        position: relative;
        margin-bottom: 1rem;
    }
`

export const Text = styled(motion.p)`

    @media all and (max-width: 650px) {
        width: 55%;
    }
`

export const ImgContainer = styled(motion.picture)`
    position: relative;
    top: 3rem;
    pointer-events: none;

    @media all and (max-width: 650px) {
        position: absolute;
        top: 2rem;
        left: 8rem;
    }
`

export const Button = styled(motion(Link))`
    display: inline-block;
    background-color: var(--main-color);
    border-radius: 10px;
    padding: 1rem 2rem;
    font-size: 1rem;
    margin: 1rem 0;

    @media all and (max-width: 650px) {
       font-size: .9rem;
       padding: 1rem;
    }
`